import Shader from './Shader';
import * as Uniform from '../Uniform';
import FRAG_SIMPLE_DRAW from './Fragment/simple_draw.frag';

export default class SimpleDrawShader extends Shader {
	protected textures:string[] = ["u_background"];

	public frag = ():string => FRAG_SIMPLE_DRAW;
}